module.exports = __webpack_public_path__ + "4cfe109c16d68b2759056f66ab6498af.png";